import script from "./SecondaryCategoryPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryCategoryPopup.vue?vue&type=script&setup=true&lang=js"

import "./SecondaryCategoryPopup.vue?vue&type=style&index=0&id=b6a31e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6a31e40"]])

export default __exports__